import React from "react";
import { BsInstagram, BsMessenger } from "react-icons/bs";
import { FaFacebook, FaTiktok } from "react-icons/fa";

import { MdCall, MdMail, MdMap } from "react-icons/md";
import { GiWorld } from "react-icons/gi";
import logo from "../../../assets/images/osportwears/IMG_2302.jpg";
const Footer = () => {
  return (
    <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 bg-[#294C6A] text-white pt-24 pb-20 gap-10 titlefont px-10">
      <div className="flex flex-col gap-7">
        <div>
          <img src={logo} className="w-20 rounded-full" alt="" />
        </div>
        <div className=" text-sm w-60 leading-6 tracking-wide">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores,
          culpa quae placeat enim corrupti ullam nemo, provident deleniti rem
        </div>
      </div>
      <div className=" flex flex-col gap-7">
        <h1 className=" text-[22px] uppercase  tracking-wider font-medium">
          {" "}
          Categories{" "}
        </h1>
        <div className="flex flex-col gap-3">
          <p>Men</p>
          <p>Women</p>
          {/* <p>Contact</p> */}
          <p>Kid</p>
          <p>Sports</p>
        </div>
      </div>
      <div className=" flex flex-col gap-7">
        <h1 className=" text-[22px] tracking-wider font-medium"> Contact</h1>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <p className="">
              <MdMap />
            </p>
            <p className="text-sm">
              NO.61/ ROYAL SHWE MYINTZU CONDO/ NEW UNIVERSITY AVE ROAD/, Yangon,
              Myanmar
            </p>
          </div>
          <div className="flex items-center gap-3">
            <p className="">
              <MdCall />
            </p>
            <p className="text-sm">09 897 779697</p>
          </div>
        </div>
      </div>
      <div className="  text-sm lg:justify-self-end self-end flex gap-5 flex-col-reverse md:flex-col  ">
        <p className="lg:text-end">
          Copyright © {new Date().getFullYear()}- All rights reserved by{" "}
          <span className="font-bold block md:inline">O Sportswear</span>
        </p>
        <div className="flex lg:justify-end  gap-5">
          <a href="https://www.facebook.com/profile.php?id=100090704671364 ">
            <FaFacebook size={24} />
          </a>
          <a href="https://www.facebook.com/messages/t/116982241325022">
            <BsMessenger size={24} />
          </a>
          <a href="#">
            <BsInstagram size={24} />
          </a>
          <a href="https://www.tiktok.com/@osport22?_t=8ir5y6blyIa&_r=1">
            <FaTiktok size={24} />
            {/* <BsInstagram size={24} /> */}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
